export default __webpack_public_path__ + "static/media/check.b416476e.svg";